// Customer Service "Track your parcel" (GCHM-99).
// Live-validates the order number: non-empty shows the valid state (green border + check),
// empty (after interaction or on submit) shows the required-field error (red border + icon +
// message). On a valid submit it opens the carrier tracking URL in a new tab:
//   {data-url}?{data-param}={data-prefix}{value}
// Progressive enhancement: if this script does not run, the wrapped <form> still submits a
// plain GET ({param}={value}, no prefix/validation). When it runs, JS takes full control.

class TrackOrderForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input');
    if (!this.form || !this.input) return;

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.input.addEventListener('input', () => this.validate());
    this.input.addEventListener('blur', () => this.validate());
  }

  // Returns true when the input holds a value. Reflects the result as is-valid / is-error.
  validate() {
    const valid = this.input.value.trim().length > 0;
    this.classList.toggle('is-valid', valid);
    this.classList.toggle('is-error', !valid);
    this.input.setAttribute('aria-invalid', valid ? 'false' : 'true');
    return valid;
  }

  handleSubmit(event) {
    event.preventDefault();

    if (!this.validate()) {
      this.input.focus();
      return;
    }

    const base = this.dataset.url;
    const param = this.dataset.param;
    const prefix = this.dataset.prefix || '';
    if (!base || base === '#' || !param) return;

    let url;
    try {
      url = new URL(base, window.location.origin);
    } catch (error) {
      return;
    }

    url.searchParams.set(param, prefix + this.input.value.trim());
    window.open(url.toString(), '_blank', 'noopener');
  }
}

if (!customElements.get('track-order-form')) {
  customElements.define('track-order-form', TrackOrderForm);
}
